import { render, staticRenderFns } from "./step-select-building-type.vue?vue&type=template&id=399176b0&scoped=true&"
import script from "./step-select-building-type.vue?vue&type=script&lang=js&"
export * from "./step-select-building-type.vue?vue&type=script&lang=js&"
import style0 from "./step-select-building-type.vue?vue&type=style&index=0&id=399176b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "399176b0",
  null
  
)

export default component.exports